import { shallowEqual, useSelector } from 'react-redux'

type User = {
  allow_edit_bank_details?: boolean
  allow_to_participate_in_orders_students?: {
    [studentId: string]: boolean
  }
  code_to_mail?: boolean
  jivo_code?: string
  must_enable_e_money?: null | boolean
  phone_enabled?: boolean
  requires_bankcard_pan_number?: boolean
  students_compensation?: {
    [studentId: string]: {
      compensation_by_statement: boolean
      compensation_by_cabinet: boolean
    }
  }
  timezone?: string
  tokens?: {
    [token: string]: {
      service: string
      token: string
      vendor: string
    }
  }
  err: string | null
  loading: boolean
  result: string
  id: number | null
  parent: null | {
    id: number
  }
  student: null | {
    id: number
  }
  employee: null | {
    id: number
  }
  update: {
    password: boolean
    phone: boolean
  }
  name: {
    first: string
    middle: string
    last: string
  }
  avatar: string
  committees: Array<number>
  email: null | string
  phone: null | string
  expired: number
  savingToken: boolean
  balance: {
    primary: null | number
    cafeteria: null | number
    primaryBalanceHidden?: boolean
  }
  role_id: null | number
  type: 'parent' | 'student' | 'employee' | ''
  shop: {
    enabled: boolean
    user_id: null | string
    user_token: null | string
  }
}

export function useUser() {
  const value: User = useSelector((state: any) => state.user, shallowEqual)
  return value
}
